import * as classic from "./classic";
import * as compact from "./compact";
import * as executive from "./executive";
import * as minimal from "./minimal";
import * as modern from "./modern";

export const TEMPLATES = [classic, modern, compact, minimal, executive].map(({ meta, renderDocument }) => ({
	id: meta.id,
	name: meta.name,
	renderDocument,
}));

export type { TailoredResume } from "./markdown";
